import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';

const WithdrawalSuccess = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation('Modal');

  return (
    <Modal title={t('WithdrawalSuccess.title')}>
      <p>{t('WithdrawalSuccess.info')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('WithdrawalSuccess.button')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default WithdrawalSuccess;
